import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-group.module.scss";

export class EntityScoresGroupHeaderEntityProps extends BaseProps {}

export const EntityScoresWidgetGroupHeaderEntity = observer(({group, controller}: EntityScoresGroupHeaderEntityProps) => {
  const {state} = controller;
  const {entityContext} = state;
  const {shouldRenderEntityHeader} = entityContext;
  const {entity} = group;
  const {name, country} = entity;

  const competitorLogoProps = {
    className: classNames(styles.logo),
    entity,
    width: 24,
    height: 24,
  };

  return (
    shouldRenderEntityHeader ? <div className={classNames(styles.header_button)}>
      <EntityLogo {...competitorLogoProps}/>
      <div className={classNames(styles.competition_and_country)}>
        <div className={classNames(styles.competition)}>{name}</div>
        <div className={classNames(styles.country)}>{country.name}</div>
      </div>
    </div> : null
  );
});
